import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { MatterGetOneV2ResponseDto } from '../../../../backend/src/matter/dto/matter-get-one-v2.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetMatterV2 = (id: string | undefined) => {
  const { fetchConfigGET } = useGetFetchConfig();
  const navigate = useNavigate();

  const getMatterData = async () => {
    const response = await fetch(`${APIBaseChronos}/api/matters/${id}/v2`, fetchConfigGET);
    if (!response.ok) {
      throw new Error('Fetching matter data failed');
    }
    // Check if the user is not authorised to view this matter
    if (response.status === 403) {
      toast.error('Unauthorized. You are being redirected to the matters explorer.');
      navigate(`/matters`);
    }

    return await response.json();
  };

  return useQuery<MatterGetOneV2ResponseDto, Error>([QueryEntity.MatterV2, id], getMatterData, {
    enabled: !!id,
    refetchOnWindowFocus: false,
  });
};
